import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import Students from "../views/Students.vue";
import StudentDetail from "../views/StudentDetail.vue";
import Courses from "../views/Courses.vue";
import CourseDetail from "../views/CourseDetail.vue";
import Attendance from "../views/Attendance.vue";
import Calendar from "../views/Calendar.vue";
import Login from "../views/Login.vue";
import CourseInquiries from "../views/CourseInquiries.vue"; 
import { useAuthStore } from "@/stores/auth.js";
import Exams from "../views/Exams.vue";
import ExamDetail from "../views/ExamDetail.vue";

const routes = [
  { 
    path: "/", 
    component: Home,
  },
  { 
    path: "/calendar", 
    component: Calendar,
    meta: { requiresAuth: true, allowedRoles: ['ADMIN', 'USER'] }
  },
  { 
    path: "/students", 
    component: Students,
    meta: { requiresAuth: true, allowedRoles: ['ADMIN'] }
  },
  { 
    path: "/students/:id", 
    component: StudentDetail,
    meta: { requiresAuth: true, allowedRoles: ['ADMIN', 'USER'] }
  },
  { 
    path: "/courses", 
    component: Courses,
    meta: { requiresAuth: true, allowedRoles: ['ADMIN'] }
  },
  { 
    path: "/courses/:id", 
    component: CourseDetail,
    meta: { requiresAuth: true, allowedRoles: ['ADMIN', 'USER'] }
  },
  { 
    path: "/session/:session_id/attendance", 
    component: Attendance,
    meta: { requiresAuth: true, allowedRoles: ['ADMIN', 'USER'] }
  },
  {
    path: "/course-inquiries",
    component: CourseInquiries,
    meta: { requiresAuth: true, allowedRoles: ['ADMIN', 'USER'] }
  },
  { 
    path: "/login", 
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: "/profile",
    component: Login,
    meta: { requiresAuth: true, allowedRoles: ['ADMIN', 'USER'] }
  },
  {
    path: "/exams",
    component: Exams,
    meta: { requiresAuth: true, allowedRoles: ['ADMIN', 'USER'] }
  },
  {
    path: "/exams/:exam_id",
    component: ExamDetail,
    meta: { requiresAuth: true, allowedRoles: ['ADMIN', 'USER'] }
  },
  //. Add a catch-all for unauthorized access
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation guard
router.beforeEach((to, from, next) => {
  const auth = useAuthStore();
  // console.log(`Navigating to: ${to.path}, requiresAuth: ${to.meta.requiresAuth}, isLoggedIn: ${auth.isLoggedIn}, currentRole: ${auth.currentRole}`);
  if(to.path === '/login' && auth.isLoggedIn) {
    // If already logged in, redirect to home
    next('/');
    return;
  }
  if (to.meta.requiresAuth && !auth.isLoggedIn) {
    // Clear any stale auth data and redirect to login
    localStorage.setItem('redirectUrl', to.fullPath);
    auth.logout();
    next('/login');
  } else if (to.meta.requiresAuth && to.meta.allowedRoles) {
    if (!to.meta.allowedRoles.includes(auth.currentRole)) {
      // Redirect to home if not authorized
      next('/');
    } else {
      next();
    }
  } else {
    next();
  }
});
export default router;